import Head from "next/head";
import { MaterialLayout } from "../components/global/layout/material/MaterialLayout";
import { GetServerSidePropsContext } from "next";
import {
  CoachCrests,
  CoachFeaturedHeroSection,
  CoachGetStarted,
  CoachHomepageFeaturedQA,
} from "../components/homepage/CoachHomepage";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

export default function CoachLandingPage() {
  const { t } = useTranslation(["index"]);

  return (
    <MaterialLayout>
      <Head>
        <title>{t("index:page-title")}</title>
        <meta name="dc.title" content={t("index:page-title")} />
        <meta name="og:title" content={t("index:page-title")} />
        <meta name="twitter:title" content={t("index:page-title")} />

        <meta
          name="description"
          content="Pod1um | Sports Performance | Strength & Conditioning Coaches, Plans & Workouts | Experience Elite"
        />
        <meta
          name="dc.description"
          content="Pod1um | Sports Performance | Strength & Conditioning Coaches, Plans & Workouts | Experience Elite"
        />
        <meta
          name="og:description"
          content="Pod1um | Sports Performance | Strength & Conditioning Coaches, Plans & Workouts | Experience Elite"
        />
        <meta
          name="twiter:description"
          content="Pod1um | Sports Performance | Strength & Conditioning Coaches, Plans & Workouts | Experience Elite"
        />
      </Head>

      <div className="flex flex-col gap-[7rem]">
        <CoachFeaturedHeroSection />
        <CoachCrests />

        <img
          className="w-full h-[17.5rem] sm:h-[40rem] md:w-[52rem] md:h-[43rem] lg:w-[70rem] lg:h-[53rem] object-contain mx-auto"
          alt="coach landing page laptop | Pod1um"
          src="/images/coach-landing-page-laptop.png"
        />

        <CoachGetStarted />
        <CoachHomepageFeaturedQA />
      </div>
    </MaterialLayout>
  );
}

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  const { locale } = context;

  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "menu",
        "footer",
        "index",
        "log-details",
      ])),
      // allBlogs
    },
  };
};
